import { getRouteDefaultParamsMap } from '../../CommonComponents/Router/utils/getRouteDefaultParamsMap';
import { OnboardingWorkflow } from '../../CommonSelectors/CommonArea.types';
import { WorkflowIdEnum } from '../../Workflow/api/useWorkflowDataQuery';

const REDIRECT_COMPONENTS = ['BeFi20Workflow', 'BeFi20Overview'];

interface RouteInfo {
  component: string;
  params: Record<string, any>;
}

export const getConsumerLandingRouteInfo = (): RouteInfo => {
  const {
    Id: clientId,
    ConsumerAccessWorkflow: onboardingWorkflow,
    ComponentName: componentName,
    ComponentProps: componentProps,
  } = ADV.data.user;

  const { id, params } = ADV.util.Router.getObjFromHash(ADV.util.getHash());

  if (REDIRECT_COMPONENTS.includes(id)) {
    return {
      component: id,
      params,
    };
  }

  const defaultComponentName = componentName || 'ConsumerOverview';

  if (defaultComponentName === 'ApexAccount') {
    return {
      component: defaultComponentName,
      params: { clientId, ...componentProps },
    };
  }

  if (defaultComponentName === 'AccountPerformanceReporting') {
    return {
      component: defaultComponentName,
      params: { clientId, isLandingPageOption: true, ...componentProps },
    };
  }

  switch (onboardingWorkflow) {
    case OnboardingWorkflow.None:
      return {
        component: defaultComponentName,
        params: getRouteDefaultParamsMap(clientId)[defaultComponentName],
      };

    case OnboardingWorkflow.AllWorkflows:
    case OnboardingWorkflow.Comprehensive:
      return {
        component: componentName || 'ConsumerWorkflowStart',
        params: {
          clientId,
          workflowId: WorkflowIdEnum.Comprehensive,
          stepId: 0,
          pivotId: 0,
          pageId: 'start',
        },
      };

    case OnboardingWorkflow.AssetBucketingWorkflow:
      return {
        component: componentName || 'ConsumerWorkflowStart',
        params: {
          clientId,
          workflowId: WorkflowIdEnum.AssetBucketing,
          stepId: 0,
          pivotId: 0,
          pageId: 'start',
        },
      };

    case OnboardingWorkflow.RiskToleranceWorkflow:
      return {
        component: 'RiskToleranceWorkflow',
        params: { clientId },
      };

    case OnboardingWorkflow.BeFi20Workflow:
      return {
        component: componentName,
        params: { clientId },
      };

    case OnboardingWorkflow.EstatePlanning:
      return {
        component: componentName,
        params: { clientId },
      };

    default:
      return {
        component: defaultComponentName,
        params: { clientId },
      };
  }
};
